import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import ProductStoreUpsellList from '../component/fpg/list/ProductStoreUpsellList'
import FilterActiveIcon from '../icons/filteractiveicon'
import FilterIcon from '../icons/filtericon'
import PlusIcon from '../icons/plusicon'
import MainLayout from '../mainLayout'
//moment import
import moment from "moment-timezone";
//Service import
import service from "../services";
import { connect } from 'react-redux'
import { bindActionCreators } from "redux";
import { ActCreators } from "../redux/bindActionCretor";

let sub;

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActCreators, dispatch);
};
class productstoreupsell extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            getLastUpdated: '',
            loaderFlag: false,
            data:[
                {
                    "label":"Store Upsell Products",
                    "Content":"This is content for Tab 1",
                }
            ]
        }
        this.apiserve = new service();
    }

    componentDidMount() {
        this.getProductLastUpdate();
        this.getLastUpdatedTimeandDate();
        this.getAllProductCouponList();
         this.setState({
           loaderFlag: true,
         });
       }
    
       getProductLastUpdate = () => {
        sub = this.apiserve.getevent().subscribe((response) => {
            switch(response.event){
                case 'ticketCms|storeProducts|getLastUpdated':
                    this.setState({
                        getLastUpdated : response.data
                    })
                    break;
                case "ticketCms|storeProducts|getList":
                    this.setState(
                        {
                            getAllProductCouponListDetails: response.data,
                            getAllProductCouponListtotaldocs: response.data.docs,
                        },
                        () => {
                            this.setState({
                                loaderFlag: false,
                                pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                            });
                        }
                    );
                    break;
            }
        })
    }

    getLastUpdatedTimeandDate = () => {
        this.apiserve.sendevent("ticketCms|storeProducts|getLastUpdated", {});
    }

    getAllProductCouponList = () => {
        this.apiserve.sendevent("ticketCms|storeProducts|getList", {});
    };

    addProducts = () => {
        this.props.StoreProductEditList('')
        this.props.history.push('/product-store-detail');
    }
    render() {
        const { getLastUpdated } = this.state;
        var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt);
        var hour = moment.tz(updateAt, "US/Mountain").format("h");
        var minutes = moment.tz(updateAt, "US/Mountain").format("mm");
        var state = moment.tz(updateAt,"US/Mountain").format("A");
        var updatedBy = getLastUpdated && getLastUpdated.updatedBy;
        return (
            <React.Fragment>
                <div className="right_side_wrapper">
                    <ul className="fpg_admin_tab disp_flex">
                        {
                            this.state.data && this.state.data.map((list,index) => {
                                return(
                                    <li className="active" >
                                        <p className="uppercase text_left">
                                         <div>{list.label}</div>
                                         {this.state?.getAllProductCouponListtotaldocs?.length <= 7 && <span onClick={this.addProducts}><PlusIcon /></span>}
                                        </p>
                                    </li>
                                )
                            })
                        }
                    </ul>
                   
                    <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                        <p></p>
                        <p className="update_date">Last Update: {hour}:{minutes} {state} -{" "}
                        {moment.tz(updateAt,"US/Mountain").format("MM/DD/YYYY")} Last Updated By:{" "}
                        {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname}</p>
                    </div>
                    <div className="table_wrap product_list_tbl film_list_table striped_table">
                        <ProductStoreUpsellList history={this.props.history}/>
                    </div>                               
                </div>
        </React.Fragment>  
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(productstoreupsell)
